// Common styles for overlay components
export const commonOverlayStyle = {
  position: "absolute",
  background: "rgba(0, 0, 0, 0.8)",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 99999,
  color: "white",
  fontSize: "20px",
  flexDirection: "column",
  gap: 12,
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)",
};
